
import PairingSettingsService from './PairingSettingsService';

export { default } from './PairingSettingsService';
export const pairingSettingsService = new PairingSettingsService();